import { Component } from '@angular/core';

@Component({
  selector: 'app-qr-code-icon',
  templateUrl: './qr-code-icon.component.html',
  styleUrl: './qr-code-icon.component.scss',
})
export class QrCodeIconComponent {}
